import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';

import axios from 'axios';

import { updateDropZone } from 'store/common/commonActions';
import { removeFichier } from 'store/fichier/fichierActions';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import SvgIcon from '@mui/material/SvgIcon';

import CircularProgress from '@mui/material/CircularProgress';

import green from '@mui/material/colors/green';

import FournisseurGestionAutocomplete from 'components/Shared/FournisseurGestionAutocomplete';
import DropZone from 'components/Shared/DropZone';

import FournisseurGestionConditionsSAVEditeur from './FournisseurGestionConditionsSAVEditeur';

import CheckImportConditionsSAVDialog from './CheckImportConditionsSAVDialog';
import ImportConditionsSAVDialog from './ImportConditionsSAVDialog';


const styles = theme => ({
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },

    link: theme.style.link,

    button: {
        margin: '8px 8px 0px 0px'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    leftIcon: {
        marginRight: theme.spacing(1)
    },
    rightIcon: {
        marginLeft: theme.spacing(1)
    },
    iconSmall: {
        fontSize: 20
    },

});

class AdministrationConditionsSAV extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fournisseur: null,
            editing: false,

            downloadingConditionsFournisseur: false,
            downloadingConditionsFournisseurs: false,
            downloadingConditionsFournisseurErreur: false,
            downloadingConditionsFournisseursErreur: false,

            fichiersIds: [],
            checkingImport: false,
            checkingImportErreur: false,
            importing: false,
            importingErreur: false,

        };
    }

    handleChangeFournisseur = (fournisseur) => {
        this.setState(
            {
                ...this.state,
                fournisseur: fournisseur
            });
    };

    handleClickEdit = () => {
        this.setState(
            {
                ...this.state,
                editing: true
            });
    };

    handleClickTerminer = () => {
        this.setState(
            {
                ...this.state,
                editing: false,
                fournisseur: null
            });
    };

    handleChange = (event) => {

        let newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);
    }

    handleDownloadConditionsFournisseurs = () => {

        console.log("handleDownloadConditionsFournisseurs");
        this.setState({ downloadingConditionsFournisseurs: true, downloadingConditionsFournisseursErreur: false });


        axios.post(`api/fournisseurs/exporter-conditionsSAV`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch((error) => {
                console.log(error);
                this.setState({ downloadingConditionsFournisseursErreur: true });
            })
            .then(() => {
                // always executed
                this.setState({ downloadingConditionsFournisseurs: false });
            });
    };

    handleDownloadConditionsFournisseur = (fournisseurId) => {

        console.log("handleDownloadConditionsFournisseur", fournisseurId);
        this.setState({ downloadingConditionsFournisseur: true, downloadingConditionsFournisseurErreur: false });


        axios.post(`api/fournisseurs/${fournisseurId}/exporter-conditionsSAV`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch((error) => {
                console.log(error);
                this.setState({ downloadingConditionsFournisseurErreur: true });
            })
            .then(() => {
                // always executed
                this.setState({ downloadingConditionsFournisseur: false });
            });
    };

    handleCheckImport = () => {

        let { fichiersIds } = this.state;

        let fichierId = fichiersIds[0];

        console.log("handleCheckImport", this.state.fichiersIds);
        this.setState({ checkingImport: true, checkingImportErreur: false });

        axios.get(`api/fournisseurs/controler-import-conditionsSAV?fichierId=${fichierId}`)
            .then((response) => {

                console.log("handleCheckImport response", response);
                this.setState({ checkImportData: response.data });
            })
            .catch((error) => {
                console.log(error);
                this.setState({ checkingImportErreur: true });
            })
            .then(() => {
                // always executed
                this.setState({ checkingImport: false });
            });
    };

    handleImport = () => {

        let { fichiersIds } = this.state;

        let fichierId = fichiersIds[0];

        console.log("handleImport", this.state.fichiersIds);
        this.setState({ importing: true, importingErreur: false });

        axios.get(`api/fournisseurs/importer-conditionsSAV?fichierId=${fichierId}`)
            .then((response) => {

                console.log("handleImport response", response);


                this.setState({ importData: response.data });
            })
            .catch((error) => {
                console.log(error);
                this.setState({ importingErreur: true });
            })
            .then(() => {
                // always executed
                this.setState({ importing: false });
            });
    };

    handleCancelImport = () => {
        this.props.removeFichier(this.state.fichiersIds[0]);

        this.setState({ checkImportData: null, fichiersIds: [] });


        var dropZone = {
            fichiers: []
        };
        this.props.updateDropZone(dropZone);
    };

    handleCloseImportConditionsSAVDialog = () => {
        this.setState({ checkImportData: null, importData: null, fichiersIds: [] });


        var dropZone = {
            fichiers: []
        };
        this.props.updateDropZone(dropZone);

    }


    render() {
        let { fournisseur, editing, downloadingConditionsFournisseur,
            downloadingConditionsFournisseurs, fichiersIds, checkingImport,
            importing, checkImportData, importData } = this.state;

        let { classes } = this.props;

        let SpreadSheetIcon = (
            <SvgIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{ width: '20px', height: '20px' }} viewBox="0 0 20 20" >
                <path d="M19,11V9H11V5H9V9H5V11H9V19H11V11H19M19,3C19.5,3 20,3.2 20.39,3.61C20.8,4 21,4.5 21,5V19C21,19.5 20.8,20 20.39,20.39C20,20.8 19.5,21 19,21H5C4.5,21 4,20.8 3.61,20.39C3.2,20 3,19.5 3,19V5C3,4.5 3.2,4 3.61,3.61C4,3.2 4.5,3 5,3H19Z" />
            </SvgIcon>
        );

        return (
            <React.Fragment>

                <CheckImportConditionsSAVDialog
                    checkImportData={checkImportData}
                    onCancel={this.handleCancelImport}
                    onClickImport={this.handleImport}
                    importing={importing}
                />

                <ImportConditionsSAVDialog importData={importData} onClose={this.handleCloseImportConditionsSAVDialog} />

                <Typography gutterBottom variant="h5">
                    Administration des conditions S.A.V. des fournisseurs
                </Typography>

                <Card className={classes.paper}>
                    {(fournisseur === null || !editing) && (

                        <React.Fragment>
                            <CardContent>
                                <Typography gutterBottom variant="h6">
                                    Veuillez sélectionner un fournisseur
                                </Typography>

                                <FournisseurGestionAutocomplete onChange={this.handleChangeFournisseur} required autoriseSAV />

                            </CardContent>

                            <CardActions>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.handleClickEdit}
                                    disabled={!fournisseur || fournisseur.id === 0}
                                >
                                    Consulter
                                </Button>

                            </CardActions>

                        </React.Fragment>
                    )}

                    {fournisseur !== null && editing && (

                        <React.Fragment>

                            <CardContent>
                                <Typography gutterBottom variant="h6">
                                    {fournisseur.code} - {fournisseur.nom}
                                </Typography>

                                <FournisseurGestionConditionsSAVEditeur fournisseurId={fournisseur.id} />
                            </CardContent>

                            <CardActions>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.handleClickTerminer}
                                >
                                    Retour
                                </Button>

                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={e => this.handleDownloadConditionsFournisseur(fournisseur.id)}
                                    disabled={downloadingConditionsFournisseur}
                                >
                                    {SpreadSheetIcon} Exporter conditions SAV

                                    {downloadingConditionsFournisseur && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </Button>
                            </CardActions>

                        </React.Fragment>
                    )}
                </Card>

                {(fournisseur === null || !editing) && (

                    <Card className={classes.paper}>

                        <CardContent>
                            <Typography gutterBottom variant="h6">
                                Conditions SAV de tous les fournisseurs
                            </Typography>
                        </CardContent>
                        <CardActions>

                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.handleDownloadConditionsFournisseurs}
                                disabled={downloadingConditionsFournisseurs}
                            >
                                {SpreadSheetIcon} Exporter

                                {downloadingConditionsFournisseurs && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </Button>

                        </CardActions>
                    </Card>
                )}

                {(fournisseur === null || !editing) && (

                    <Card className={classes.paper}>

                        <CardContent>
                            <Typography gutterBottom variant="h6">
                                Import Conditions SAV
                            </Typography>

                            <DropZone
                                disabled={checkingImport || importing}
                                id="fichiersIds"
                                name="fichiersIds"
                                onChange={this.handleChange}
                                label="Fichier à importer"
                                buttonLabel="Ajouter un fichier"
                                maxNbOfFiles={1}
                            />
                        </CardContent>

                        <CardActions>

                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.handleCheckImport}
                                disabled={checkingImport || importing || fichiersIds.length === 0 || fichiersIds[0] === 0}
                            >
                                {SpreadSheetIcon} Importer

                                {checkingImport && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </Button>

                        </CardActions>
                    </Card>
                )}

            </React.Fragment>
        );
    }
}

AdministrationConditionsSAV.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => ({
    updateDropZone: (dropZone) => dispatch(updateDropZone(dropZone)),
    removeFichier: id => dispatch(removeFichier(id)),
});

export default connect(null, mapDispatchToProps)(withStyles(styles)(AdministrationConditionsSAV));

